
import { Dispatch } from "redux";
import {
  loadColorCodes,
  loadDocuments,
  loadRelations,
  loadTasklist,
  loadTasks,
  loadUsers,
  loadVersions
} from "../../Services/ProgrammationService";

import { getTasksColorCodes, getTasksUsers } from "../../Helpers/TasksHelper";

export const cleanProgrammationAction = () => {

  return {
    type: 'PROGRAMMATION_CLEANUP'
  }
}

export const setProgrammationAction = (payload: any) => {

  return async (dispatch: Dispatch) => {

    dispatch({
      type: 'PROGRAMMATION_LOAD_END',
      payload,
    })

    dispatch({
      type: 'DASHBOARD_LOAD_NONE'
    })
    dispatch({
      type: 'MACRO_LOAD_NONE'
    })
    dispatch({
      type: 'LOOKAHEAD_LOAD_NONE'
    })
    dispatch({
      type: 'WEEKLY_LOAD_NONE'
    })
    dispatch({
      type: 'TASKS_LOAD_NONE'
    })
    dispatch({
      type: 'RESOURCES_RESTRICTIONS_LOAD_NONE'
    })
  }
}
